import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axiosClient';
import { dispatch } from '../index';

// `hien` để null nghĩa là chưa ai bấm gì trong phiên này -> dùng giá trị từ /me.
// Chỉ khi hạnh sinh tự bấm tắt/bật thì slice mới giữ giá trị đè lên, nhờ vậy popup
// biến mất ngay lập tức mà không phải chờ tải lại /me.
const initialState = {
    hien: null,
    dangLuu: false,
    error: null
};

const slice = createSlice({
    name: 'thongBaoTrangChu',
    initialState,
    reducers: {
        // Đổi tài khoản trong cùng tab: store nằm ở module-level và không persist, nên
        // lựa chọn của người trước còn nguyên trong RAM sau khi đăng xuất.
        datLai() {
            return { ...initialState };
        },
        // Đổi `hien` ngay lúc bấm chứ không đợi server: hạnh sinh vừa bấm "Không hiển thị
        // lại" mà popup còn nằm đó vài giây thì trông như bấm hụt.
        luuStart(state, action) {
            state.dangLuu = true;
            state.error = null;
            state.hien = action.payload;
        },
        luuSuccess(state) {
            state.dangLuu = false;
        },
        // Server từ chối -> trả về đúng giá trị trước khi bấm. Thà hiện thừa một lần nữa
        // còn hơn để hạnh sinh tưởng đã tắt vĩnh viễn mà thật ra chưa lưu được.
        luuFailure(state, action) {
            state.dangLuu = false;
            state.hien = action.payload.hienCu;
            state.error = action.payload.message;
        }
    }
});

export default slice.reducer;

export const { datLai } = slice.actions;

/** Bật/tắt popup thông báo trang chủ cho chính hạnh sinh đang đăng nhập. */
export function datHienThongBao(hien, hienCu) {
    return async () => {
        dispatch(slice.actions.luuStart(hien));

        try {
            await axios.post('/me/hien-thong-bao', { hien });
            dispatch(slice.actions.luuSuccess());
            return { ok: true };
        } catch (error) {
            dispatch(
                slice.actions.luuFailure({
                    hienCu,
                    message: error?.message || 'Không lưu được cài đặt.'
                })
            );
            return { ok: false };
        }
    };
}
